import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout'
import { useDispatch, useSelector } from 'react-redux'
import '../stylings/noticeAll.css'
import { Link } from 'react-router-dom'
import { hideLoading, showLoading } from '../redux store/loader'
import moment from 'moment'

const NormalNoticeAll = () => {
  const dispatch = useDispatch()
  const { notices } = useSelector((state) => state.notices)
  const [search, setSearch] = useState('')

  useEffect(() => {
    dispatch(showLoading())
    setTimeout(() => { dispatch(hideLoading()) }, 1700)
  }, [])

  const filtered = notices
    ? notices.filter((n) =>
        n.subject.toLowerCase().includes(search.toLowerCase())
      )
    : []

  return (
    <Layout>
      <div className="na-page">

        {/* ── Hero ── */}
        <div className="na-hero">
          <div className="na-hero-dots" />
          <div className="na-hero-blob na-hero-blob--1" />
          <div className="na-hero-blob na-hero-blob--2" />
          <div className="container na-hero-inner">
            <div className="na-hero-tag">
              <i className="fa-solid fa-bell"></i> School Notices
            </div>
            <h1 className="na-hero-title">All Notices</h1>
            <p className="na-hero-sub">
              Stay informed with the latest announcements, circulars and updates from Vidya Jain Convent School.
            </p>

            {/* Search */}
            <div className="na-search-wrap">
              <i className="fa-solid fa-magnifying-glass na-search-icon"></i>
              <input
                type="text"
                className="na-search-input"
                placeholder="Search notices by subject…"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              {search && (
                <button className="na-search-clear" onClick={() => setSearch('')}>
                  <i className="fa-solid fa-xmark"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        {/* ── Content ── */}
        <div className="container na-body">

          {/* Summary row */}
          {notices && (
            <div className="na-summary">
              <span className="na-summary-count">
                <i className="fa-solid fa-list-check"></i>
                {filtered.length} {filtered.length === 1 ? 'notice' : 'notices'}
                {search && ` found for "${search}"`}
              </span>
              <span className="na-summary-label">Sorted by latest</span>
            </div>
          )}

          {/* Notices */}
          {!notices ? (
            <div className="na-empty">
              <div className="na-empty-icon"><i className="fa-solid fa-bell-slash"></i></div>
              <h3>No Notices Available</h3>
              <p>There are no notices to display right now. Please check back later.</p>
            </div>
          ) : filtered.length === 0 ? (
            <div className="na-empty">
              <div className="na-empty-icon"><i className="fa-solid fa-magnifying-glass"></i></div>
              <h3>No Results Found</h3>
              <p>No notices match "<strong>{search}</strong>". Try a different keyword.</p>
            </div>
          ) : (
            <div className="na-list">
              {filtered.map((item, index) => {
                const date = moment(item.publisheddate, 'DD-MMM-YYYY hh:mm A')
                const day  = date.format('DD')
                const mon  = date.format('MMM')
                const yr   = date.format('YYYY')
                const isNew = moment().diff(date, 'days') <= 7

                return (
                  <div className="na-card" key={item.id}>

                    {/* Date block */}
                    <div className="na-card-date">
                      <span className="na-date-day">{day}</span>
                      <span className="na-date-mon">{mon}</span>
                      <span className="na-date-yr">{yr}</span>
                    </div>

                    {/* Body */}
                    <div className="na-card-body">
                      <div className="na-card-meta">
                        <span className="na-card-num">#{String(index + 1).padStart(2, '0')}</span>
                        {isNew && (
                          <span className="na-card-new">
                            <i className="fa-solid fa-circle-dot"></i> New
                          </span>
                        )}
                      </div>
                      <h3 className="na-card-subject">{item.subject}</h3>
                      <div className="na-card-footer">
                        <span className="na-card-date-text">
                          <i className="fa-solid fa-calendar"></i>
                          {date.format('DD MMM YYYY')}
                        </span>
                      </div>
                    </div>

                    {/* Action */}
                    <Link to={`/notice/${item.id}`} className="na-card-btn">
                      <span>View</span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>

                  </div>
                )
              })}
            </div>
          )}
        </div>
      </div>
    </Layout>
  )
}

export default NormalNoticeAll
